export type BusHandler = (payload: unknown) => void;

export class EventBus {
  private handlers = new Map<string, Set<BusHandler>>();

  on(event: string, handler: BusHandler): void {
    let set = this.handlers.get(event);
    if (!set) {
      set = new Set();
      this.handlers.set(event, set);
    }
    set.add(handler);
  }

  off(event: string, handler: BusHandler): void {
    this.handlers.get(event)?.delete(handler);
  }

  once(event: string, handler: BusHandler): void {
    const wrapped: BusHandler = (payload) => {
      this.off(event, wrapped);
      handler(payload);
    };
    this.on(event, wrapped);
  }

  emit(event: string, payload?: unknown): void {
    const set = this.handlers.get(event);
    if (!set) return;
    for (const h of set) {
      try {
        h(payload);
      } catch {
        // isolate subscribers — failure in one must not stop others
      }
    }
  }

  removeAllListeners(event?: string): void {
    if (event) this.handlers.delete(event);
    else this.handlers.clear();
  }
}
